import { render, staticRenderFns } from "./MyMultiSelect.vue?vue&type=template&id=a47e8996&"
import script from "./MyMultiSelect.vue?vue&type=script&lang=js&"
export * from "./MyMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports